import React  from 'react'
import {
  Container,
  LeftSection,
  RightSection,
  SectionName,
  TopHeading,
  CustomDiv
} from './style'
import { useNavigate } from 'react-router-dom'
import Button from 'components/Button'
import RoutePath from 'components/RoutePath'
import SearchInput from 'components/SearchInput'
import LeftArrow from 'components/icons/LeftArrow'

const DraftHeader = ({
  currentStep,
  isCompanyContext,
  handleTableNavigation,
}) => {

  const handleBackClick = () => {
    navigate(-1)
  }

  const navigate = useNavigate()
  const handleAddRole = () => {
    navigate('/events/newevent')
  }

  return (
    <>
      <Container spaceBetween>
        <LeftSection centerVertically>
          <CustomDiv>
            <LeftArrow onClick={handleBackClick} />
          </CustomDiv>
          <CustomDiv
            onClick={() =>
              isCompanyContext
                ? handleAddNewCompany(false)
                : handleTableNavigation()
            }
          ></CustomDiv>

          <SectionName column>
            <RoutePath from="Events" path="/events" />
            <TopHeading>Drafts</TopHeading>
          </SectionName>
        </LeftSection>
        <RightSection>
          <Button.Primary
            text={currentStep == 3 ? 'Submit' : 'Add New Event'}
            onClick={handleAddRole}
          />
        </RightSection>
      </Container>
      <SearchInput
        placeholder="Search by keyword"
        width="98%"
        height="42px"
        background="white"
      />
    </>
  )
}

export default DraftHeader
